import * as Yup from 'yup'

import { RecipientDetailsValues } from '../../CreateFulfillmentOrder.types'

export const INITIAL_RECIPIENT_VALUES: RecipientDetailsValues = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  streetAddress: '',
  city: '',
  stateProvince: '',
  postalCode: '',
  country: 'US',
  deliveryInstructions: ''
}

export const US_ZIP_FIVE_OR_NINE_REGEX = /^\d{5}(-\d{4})?$/
export const US_ZIP_PLUS_FOUR_REGEX = /^\d{5}-\d{4}$/
export const GENERIC_POSTAL_CODE_REGEX = /^[A-Za-z0-9\s-]+$/

export const ZIP_PLUS_FOUR_REQUIRED_MESSAGE =
  'ZIP+4 is required — USPS could not confirm this address. Use the 12345-6789 format.'

export const ZIP_PLUS_FOUR_HINT = 'ZIP+4 (e.g. 12345-6789) recommended — improves delivery accuracy.'
export const ZIP_PLUS_FOUR_ENFORCED_HINT =
  'USPS could not confirm this address. Please provide the full ZIP+4 (e.g. 12345-6789) to continue.'

export interface BuildRecipientDetailsSchemaOptions {
  enforceZipPlus4?: boolean
}

export function buildRecipientDetailsValidationSchema({
  enforceZipPlus4 = false
}: BuildRecipientDetailsSchemaOptions = {}) {
  const usPostalCodeRule = enforceZipPlus4
    ? Yup.string()
        .trim()
        .required('This field is required')
        .matches(US_ZIP_PLUS_FOUR_REGEX, ZIP_PLUS_FOUR_REQUIRED_MESSAGE)
    : Yup.string()
        .trim()
        .required('This field is required')
        .matches(US_ZIP_FIVE_OR_NINE_REGEX, 'Enter a 5-digit ZIP or ZIP+4 (12345 or 12345-6789)')

  return Yup.object({
    firstName: Yup.string().trim().required('This field is required'),
    lastName: Yup.string().trim().required('This field is required'),
    email: Yup.string().trim().required('This field is required').email('Please enter a valid email address'),
    phone: Yup.string().trim().optional(),
    streetAddress: Yup.string().trim().required('This field is required'),
    city: Yup.string().trim().required('This field is required'),
    stateProvince: Yup.string().trim().required('This field is required'),
    country: Yup.string().trim().required('This field is required'),
    postalCode: Yup.string().when('country', {
      is: 'US',
      then: () => usPostalCodeRule,
      otherwise: () =>
        Yup.string()
          .trim()
          .required('This field is required')
          .matches(GENERIC_POSTAL_CODE_REGEX, 'Invalid postal/zip code format')
    }),
    deliveryInstructions: Yup.string()
  })
}

/** @deprecated Prefer `buildRecipientDetailsValidationSchema({ enforceZipPlus4 })`; kept for back-compat. */
export const recipientDetailsValidationSchema = buildRecipientDetailsValidationSchema()
